module.exports = __webpack_public_path__ + "ce4d6b548d9bb4a40a988831f5d28b87.svg";